import {Component, OnInit, Input, OnDestroy} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {NgSelectModule} from '@ng-select/ng-select';
import {NlrTypeheadDirective} from '../../common/directive/nlr-typehead.directive';
import {NlrpFieldRecordLocalitiesService} from '../../lodge-field-record/field-record-localities/field-record-localities.service';
import {Observable, OperatorFunction, debounceTime, distinctUntilChanged, map} from 'rxjs';
import {PlanModel} from '../../common/service/plan-model.model';
import {selectedPurpose} from '../../lodge-field-record/lodge-field-record.model';
import {selectedLodgementType} from '../../lodge-field-record/lodge-field-record.model';
import {NgEventBus} from 'ng-event-bus';

@Component({
    selector: 'nlr-field-record-address',
    imports: [FormsModule, CommonModule, NlrTypeheadDirective, NgSelectModule],
    templateUrl: './field-record-address.component.html',
    styleUrl: './field-record-address.component.scss'
})
export class FieldRecordAddressComponent implements OnInit, OnDestroy {
    planModel: PlanModel = undefined;
    roads = [];
    localityRoadSearchOption = [];
    selectedLocality = undefined;
    selectedRoad = undefined;
    submitted = false;
    isRoadNameSelected = true;

    @Input()
    model: PlanModel;
    @Input()
    selectedLodgementType: selectedLodgementType;
    @Input()
    selectedPurpose: selectedPurpose;

    localityRoadSearch: OperatorFunction<string, readonly string[]> = (text$: Observable<string>) =>
        text$.pipe(
            debounceTime(200),
            distinctUntilChanged(),
            map(term =>
                this.getlocalityRoadSearchOption()
                    .filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1)
                    .slice(0, 10)
            )
        );

    constructor(
        private nlrpFieldRecordLocalitiesService: NlrpFieldRecordLocalitiesService,
        private eventBus: NgEventBus
    ) {}

    ngOnInit(): void {
        if (!this.model.address) {
            this.model.address = {locality: {localityName: ''}};
        }
    }

    ngOnDestroy(): void {
        if (this.model.address) {
            delete this.model.address;
        }
    }

    ngDoCheck(): void {
        if (this.model.localities.length > 0) {
            if (!this.model.address) {
                this.model.address = {
                    locality: {localityName: ''}
                };
            }

            if (!this.model.address.locality.localityName || this.getLocalityNames().indexOf(this.model.address.locality.localityName) === -1) {
                this.model.address.locality.localityName = this.model.localities[0].localityName;
                this.selectedLocality = this.model.localities[0];
                this.onChangeLocality();
            }
        }
    }

    getlocalityRoadSearchOption() {
        this.isRoadNameSelected = false;
        return this.localityRoadSearchOption;
    }

    getLocalities() {
        return this.model.localities.filter(function (locality) {
            return locality.localityName;
        });
    }

    localityTrackBy(item) {
        return item.localityName;
    }

    onChangeRoadNumber(newValue: string) {
        this.model.address.roadNumber = newValue;
    }

    isLocalityRequired() {
        return (
            this.selectedLodgementType.applyAddressValidation &&
            this.selectedPurpose.address === 'Mandatory' &&
            (!this.model.formerTenures ||
                this.model.formerTenures.length == 0 ||
                this.model.formerTenures.filter(function (formerTenure) {
                    return formerTenure.parentPlanType !== 'NLOP';
                }).length > 0)
        );
    }

    isRoadRequired() {
        return this.isLocalityRequired() && this.model.address.locality && this.model.address.locality.localityName;
    }

    isRoadDisabled() {
        return !this.model.address.locality || !this.model.address.locality.localityName || !this.roads || this.roads.length === 0;
    }

    onChangeLocality() {
        this.roads.length = 0;
        if (this.model.address.road) {
            delete this.model.address.road;
            this.selectedRoad = '';
        }

        this.localityRoadSearchOption = [];

        const subscription = this.nlrpFieldRecordLocalitiesService.getRoadsByLocality(this.selectedLocality.localityName).subscribe(data => {
            Array.prototype.push.apply(this.roads, data);
            this.roads.map(v => {
                if (!this.localityRoadSearchOption.includes(v.displayName)) {
                    this.localityRoadSearchOption.push(v.displayName);
                }
            });
        });
        this.eventBus.cast('nlr:busy', subscription);
    }

    getLocalityNames() {
        return this.getLocalities().map(function (locality) {
            return locality.localityName;
        });
    }

    onSelectLocality(locality: any) {
        this.selectedLocality = locality;
        this.model.address.locality.localityName = locality.localityName;
        this.onChangeLocality();
    }

    roadNameSelected(road: string) {
        this.model.address.road = road;
        this.selectedRoad = road;
        this.isRoadNameSelected = true;
    }
}
